const getPageNumberFromPath = (path: string = '') => {
  const pathArray = path.split('/')
  const lastPartOfPathArray = pathArray.pop() || ''
  const pageNumber = lastPartOfPathArray.split('?')[0]
  return Number(pageNumber)
}

export default getPageNumberFromPath
